<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
     
          <div class="faceDatabase">   
       <div  class="faceDatabase_box">
         <div class="faceDatabase_box_imgBox">
          <image-preview :src="detailsForm.url" :width="100" :height="100" />
          <!-- <img :src="item.url" class="faceDatabase_box_img" alt="" /> -->
        </div>
        
        <div class="faceDatabase_box_name"> 
            <span>{{ detailsForm.name }}</span> 
            <span class="detailsInfo_span">
                （
<span v-for="(item, index) in detailsForm.imageTypeList" :key="index">
              {{ item.type }}
            </span>
            ）
            </span>
         
            
        </div>
        <span class="faceDatabase_box_time">{{ detailsForm.content }}</span>
        <div class="detailsInfo_box">
            <span class="faceDatabase_box_time">{{ detailsForm.createUser }}</span>
        <span class="faceDatabase_box_time">{{ detailsForm.createTime }}</span>
        </div>
        
        
       </div>
      </div>
    <!-- </div> -->
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="cancel">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { imageLibraryinfo } from "@/api/imageLibrary";
import "@/assets/imgList.css";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      btnShow: false,
      detailsNum: 3,
      detailsForm: {},
      id: null,
    }
  },
  methods: {
    addCreateForm(record) {
      this.open = true
      this.title = '详情'
     this.id = record.id
     this.getImgFun()
    },   
    getImgFun(){
 imageLibraryinfo({id:this.id}).then(response => {
          this.detailsForm = response.data.data
      })
    },
    // 取消按钮
    cancel() {
        console.log('取消')
        this.detailsForm = {}
      this.open = false
    },
  },
  mounted() {
  }
}
</script>
<style scoped>
.faceDatabase_box{
    width: 100%;    
    padding: 20px;
}
.detailsInfo_box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 50%;
    color: #888;
}
.detailsInfo_span{
    font-weight: 500;
    font-size: 14px;
    color: #1aaeae;
}
</style>


